'use strict';

// Data
const account1 = {
    owner: "Mark Trutsky",
    movements: [200, 455.23, -306.5, 25000, -642.21, -133.9, 79.97, 1300],
    interestRate: 1.2, // %
    pin: 1111,

    movementsDates: [
        "2021-11-18T21:31:17.178Z",
        "2021-12-23T07:42:02.383Z",
        "2021-01-28T09:15:04.904Z",
        "2021-04-01T10:17:24.185Z",
        "2021-05-08T14:11:59.604Z",
        "2022-07-25T17:01:17.194Z",
        "2022-07-21T23:36:17.929Z",
        "2022-07-01T10:51:36.790Z",
    ],
    currency: "EUR",
    locale: "pt-PT",
};

const account2 = {
    owner: "Jessica Davis",
    movements: [5000, 3400, -150, -790, -3210, -1000, 8500, -30],
    interestRate: 1.5,
    pin: 2222,

    movementsDates: [
        "2021-11-01T13:15:33.035Z",
        "2021-11-30T09:48:16.867Z",
        "2021-12-25T06:04:23.907Z",
        "2021-01-25T14:18:46.235Z",
        "2021-02-05T16:33:06.386Z",
        "2022-07-10T14:43:26.374Z",
        "2022-07-25T18:49:59.371Z",
        "2022-07-23T12:01:20.894Z",
    ],
    currency: "USD",
    locale: "en-US",
};

const accounts = [account1, account2];

// Elements
const labelWelcome = document.querySelector('.welcome');
const labelDate = document.querySelector('.date');
const labelBalance = document.querySelector('.balance__value');
const labelSumIn = document.querySelector('.summary__value--in');
const labelSumOut = document.querySelector('.summary__value--out');
const labelSumInterest = document.querySelector('.summary__value--interest');
const labelTimer = document.querySelector('.timer');

const containerApp = document.querySelector('.app');
const containerMovements = document.querySelector('.movements');

const btnLogin = document.querySelector('.login__btn');
const btnTransfer = document.querySelector('.form__btn--transfer');
const btnLoan = document.querySelector('.form__btn--loan');
const btnClose = document.querySelector('.form__btn--close');
const btnSort = document.querySelector('.btn--sort');

const inputLoginUsername = document.querySelector('.login__input--user');
const inputLoginPin = document.querySelector('.login__input--pin');
const inputTransferTo = document.querySelector('.form__input--to');
const inputTransferAmount = document.querySelector('.form__input--amount');
const inputLoanAmount = document.querySelector('.form__input--loan-amount');
const inputCloseUsername = document.querySelector('.form__input--user');
const inputClosePin = document.querySelector('.form__input--pin');

const formatMovmentDate = function (date, locale) {
    const calcDaysPassed = (date1, date2) => Math.round(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24));
    const daysPassed = calcDaysPassed(new Date(), date);

    if (daysPassed === 0) return 'Today';
    if (daysPassed === 1) return 'Yesterday';
    if (daysPassed <= 7) return `${daysPassed} days ago`;
    else {
        return new Intl.DateTimeFormat(locale).format(date);
    }
};

const formatCur = function (value, locale, currency) {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
    }).format(value);
};

const displayMovments = function (acc, sort = false) {
    containerMovements.innerHTML = "";
    const movs = sort ? acc.movements.slice().sort((a, b) => a - b) : acc.movements;

    movs.forEach(function (mov, i) {
        const type = mov > 0 ? "deposit" : "withdrawal";
        const date = new Date(acc.movementsDates[i]);
        const displayDate = formatMovmentDate(date, acc.locale);
        const formatedMovment = formatCur(mov, acc.locale, acc.currency);
        const html = `
            <div class="movements__row">
                <div class="movements__type movements__type--${type}">${i + 1} ${type}</div>
                <div class="movements__date">${displayDate}</div>
                <div class="movements__value">${formatedMovment}</div>
            </div>
        `;
        containerMovements.insertAdjacentHTML("afterbegin", html);
    });
};

const createUserNames = function (accs) {
    accs.forEach(function (acc) {
        acc.username = acc.owner.toLowerCase().split(' ').map(name => name[0]).join('');
    });
};
createUserNames(accounts);

const calcDisplayBalance = function (acc) {
    acc.balance = acc.movements.reduce((acc, mov) => acc + mov, 0);
    labelBalance.textContent = formatCur(acc.balance, acc.locale, acc.currency);
};

const calcDisplaySummary = function (acc) {
    const incomes = acc.movements.filter(mov => mov > 0).reduce((acc, mov) => acc + mov, 0);
    labelSumIn.textContent = formatCur(incomes, acc.locale, acc.currency);

    const outcomes = acc.movements.filter(mov => mov < 0).reduce((acc, mov) => acc + mov, 0);
    labelSumOut.textContent = formatCur(outcomes, acc.locale, acc.currency);

    const interest = acc.movements.filter(mov => mov > 0).map(deposit => deposit * acc.interestRate / 100).filter((int, i, arr) => int >= 1).reduce((acc, int) => acc + int, 0);
    labelSumInterest.textContent = formatCur(interest, acc.locale, acc.currency);
};

const updateUi = function (acc) {
    // Display movments
    displayMovments(acc);

    // Display balance
    calcDisplayBalance(acc);

    // Display summary
    calcDisplaySummary(acc);
};

const startLogOutTimer = function () {
    const tick = function () {
        const min = String(Math.trunc(time / 60)).padStart(2, 0);
        const sec = String(time % 60).padStart(2, 0);

        // in each call, print the remaining time to UI
        labelTimer.textContent = `${min}:${sec}`;

        // when timer hits 0sec, stop timer and log out the user
        if (time === 0) {
            clearInterval(timer);
            labelWelcome.textContent = "Log in to get started";
            containerApp.style.opacity = 0;
        }

        // decrease 1s
        time--;
    };

    // set time to 5 minute
    let time = 60 + 60 + 60 + 60 + 60;

    // call the timer every seconnds
    tick();
    const timer = setInterval(tick, 1000);
    return timer;
};

// login
let currentAccount, timer;

btnLogin.addEventListener("click", function (e) {
    e.preventDefault();

    currentAccount = accounts.find(acc => acc.username === inputLoginUsername.value);
    if (currentAccount?.pin === Number(inputLoginPin.value)) {
        // Displaying UI and a welcome message
        labelWelcome.textContent = `Welcome back, ${currentAccount.owner.split(' ')[0]}`;
        containerApp.style.opacity = 100;

        // adding the date
        const now = new Date();
        const options = {
            hour: 'numeric',
            minute: 'numeric',
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
        };
        labelDate.textContent = new Intl.DateTimeFormat(currentAccount.locale, options).format(now);

        // clear the input fields
        inputLoginUsername.value = inputLoginPin.value = "";
        inputLoginPin.blur();

        // timer
        if (timer) clearInterval(timer);
        timer = startLogOutTimer();

        // update ui
        updateUi(currentAccount);
    }
});

// Fake login
// currentAccount = account1;
// updateUi(currentAccount);
// containerApp.style.opacity = 100;

// transfer money
btnTransfer.addEventListener("click", function (e) {
    e.preventDefault();

    const amount = Number(inputTransferAmount.value);
    const receverAcc = accounts.find(acc => acc.username === inputTransferTo.value);

    inputTransferAmount.value = inputTransferTo.value = "";

    if (amount > 0 && currentAccount.balance >= amount && receverAcc && receverAcc?.username !== currentAccount.username) {
        currentAccount.movements.push(-amount);
        receverAcc.movements.push(amount);

        // add transfer date
        currentAccount.movementsDates.push(new Date().toISOString());
        receverAcc.movementsDates.push(new Date().toISOString());

        // updateUi
        updateUi(currentAccount);

        // reset timer
        clearInterval(timer);
        timer = startLogOutTimer();
    }
});

// close account
btnClose.addEventListener("click", function (e) {
    e.preventDefault();

    if (currentAccount.username === inputCloseUsername.value && Number(inputClosePin.value) === currentAccount.pin) {
        const index = accounts.findIndex(acc => acc.username === currentAccount.username);

        // delete account
        accounts.splice(index, 1);

        // hide UI
        containerApp.style.opacity = 0;
    }

    inputCloseUsername.value = inputClosePin.value = "";
});

btnLoan.addEventListener("click", function (e) {
    e.preventDefault();

    const amount = Number(inputLoanAmount.value);

    if (amount > 0 && currentAccount.movements.some(mov => mov >= amount / 10)) {
        setTimeout(function () {
            // add movement
            currentAccount.movements.push(amount);

            // add transfer date
            currentAccount.movementsDates.push(new Date().toISOString());

            // update UI
            updateUi(currentAccount);
        }, 2500);
    }

    inputLoanAmount.value = "";
});
